import type { ROLES } from 'src/entities/auth'
import type { RouteMeta } from 'vue-router'

// Имена роутов. Живут в shared: ими пользуются и роутер, и презентация.
export enum ROUTES {
  AUTH = 'Auth',
  AI_CONSULTANT = 'AIConsultant',
  MAIN = 'Main',
  CATALOG = 'Catalog',
  COMPARE_ITEM = 'CompareItem',
  COMPARE_LIST = 'CompareList',
  SEARCH = 'ProductSearch',
  SERVICES = 'ServicesView',
  FORBIDDEN = 'Forbidden',
  ORDER = 'Order',
  ORDER_VIEW = 'OrderView',
  ORDER_LOG = 'OrderLog',
  PROFILE = 'Profile',
  REFUND = 'Refund',
  REFUND_LIST = 'RefundList',
  REFUND_SUCCESS = 'RefundSuccess',
  ORDER_CENTER = 'OrderCenter',
  ORDER_CENTER_CART = 'OrderCenterCart',
  ORDER_CENTER_SUCCESS = 'OrderCenterSuccess',
  NEWS = 'News',
  ISSUANCE = 'Issuance',
  PAYMENT = 'Payment',
  CUSTOMER_PAGE = 'CustomerPage',

  LOADER_MAIN = 'LoaderMain',
  LOADER_ORDER_VIEW = 'LoaderOrderView',
}

export interface IRouteMeta extends RouteMeta {
  roles?: Array<ROLES>
}
